import { useFetch } from "../../hooks/useFetch";
import { useRef } from "react";

export default function SelectorQuery({handleChange, formData, url, token}){
    
    const selRef = useRef(null);

    const res = useFetch(url, token);

    while(res.response === null){
        return(<h1>Loading...</h1>)
    }

    //alert(JSON.stringify(res))

    const catList = res.response.data;

    const GetValues = () => {

        return(
            
            <>{
                catList.map((v,i) => (
                    <option key={Object.keys(v)} value={catList[i][Object.keys(v)]}>
                        {catList[i][Object.keys(v)]}
                    </option>

            ))}</>
        )
    }

    return(
        <div>
            <select className="form-control form-select"
                value={formData.jobCategoryId}
                onChange={(e) => handleChange(e)}
                name="jobCategoryId"
                ref={selRef}
            >
                <option>--Select--</option>
                <GetValues />
            </select>
        </div>

    )

}
